import { getSitesPromise } from '~/src/dash/api/channels';
import { ISite } from '~/src/dash/api/console-api';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IUserState } from '~/src/dash/reducers/user-reducers';
import { IMenuList } from '~/src/dash/types/menuList';
import { filterSiteByPrebid } from '~/src/dash/utils/models';
import { checkUserInfoMasked } from '~/src/dash/utils/roles';

export const buildUpdateMapForAPI = (objectFromState: Record<string, IMenuList>) => {
  const updateMap = {} as any;
  for (const key in objectFromState) {
    if (key === 'Channels') {
      updateMap.ChannelIDs = Object.keys(objectFromState[key]).join(',');
    }
  }
  return updateMap;
};

export type BulkUpdateChannelGroupValueKeys = 'Channels' | 'Channel Group Labels';
export type BulkUpdateChannelGroupValues = Record<
  BulkUpdateChannelGroupValueKeys,
  IBulkUpdateChannelGroupValue
>;
export interface IBulkUpdateChannelGroupValue {
  paramKey: string;
  menuTitle: BulkUpdateChannelGroupValueKeys;
  singularTitle: string;
  description?: string;
  isAPICall: boolean;
  // if isAPICall is true, use below
  getList?: (session: ISessionState, user: IUserState) => Promise<any>;
}

export type BulkUpdateChannelGroupSideBarKeys = 'Summary' | 'Channel Groups' | 'Active Fields';
export type BulkUpdateChannelGroupSideBar = Record<
  BulkUpdateChannelGroupSideBarKeys,
  IBulkUpdateChannelSideBar
>;
export interface IBulkUpdateChannelSideBar {
  rowTitle: string;
  rowDescription: string;
}

export interface IBulkUpdateChannelGroupConfig {
  valuesToUpdate: BulkUpdateChannelGroupValues;
  sideBar: BulkUpdateChannelGroupSideBar;
}

const getSitesListForBulkUpdate = (session: ISessionState, user: IUserState) => {
  return getSitesPromise({
    publisherIDs: [session.publisher.ID],
    publisherID: session.publisher.ID,
  }).then((sites: ISite[]) => {
    sites = sites.filter((site: ISite) => {
      return site.SubscriptionType === 4;
    });
    const siteList: IMenuList = {};
    filterSiteByPrebid(sites).forEach((site: ISite) => {
      const siteName = checkUserInfoMasked(user.user) ? `demo_site_${site.ID}` : site.Name;
      siteList[site.ID] = {
        title: siteName,
        selected: false,
        ID: site.ID.toString(),
      };
    });
    return siteList;
  });
};

export const bulkUpdateChannelGroupsConfig: IBulkUpdateChannelGroupConfig = {
  valuesToUpdate: {
    Channels: {
      menuTitle: 'Channels',
      singularTitle: 'Channel',
      description: 'These channels will be added to the selected channel groups',
      isAPICall: true,
      getList: (session: ISessionState, user: IUserState) =>
        getSitesListForBulkUpdate(session, user),
    } as IBulkUpdateChannelGroupValue,
  } as BulkUpdateChannelGroupValues,
  sideBar: {
    Summary: {
      rowTitle: 'Summary',
      rowDescription: 'Current edits will impact the following:',
    },
    'Channel Groups': {
      rowTitle: 'Channel Groups',
      rowDescription: ' Selected',
    },
    'Active Fields': {
      rowTitle: 'Active Fields',
      rowDescription: 'Select a field to edit',
    },
  } as BulkUpdateChannelGroupSideBar,
} as IBulkUpdateChannelGroupConfig;
